import { Component, OnInit, Input, AfterViewInit, Inject, OnDestroy, OnChanges } from '@angular/core';
import { Chart, StockChart } from 'angular-highcharts';
import { Highcharts$, Constants, DateService, Moment$, FabricService, WarningDialog } from 'src/app/shared/index';
import { Router, RouterLink, ActivatedRoute, ParamMap } from '@angular/router';
import * as moment from 'moment';
import { DatePipe, DecimalPipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material';
import { MatDialogRef, MatDialog, MatSelectionListChange, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService, SiteService, ClickAndNavigationService } from 'src/app/services/index';
import { constants } from 'zlib';
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MM-DD',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-sensor-trend-modal',
  templateUrl: './sensor-trend-modal.component.html',
  styleUrls: ['./sensor-trend-modal.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    // {provide: MAT_DATE_LOCALE, useValue: 'hi-IN'},
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SensorTrendModalComponent implements OnInit {
  formData: FormGroup;
  humidChart: Chart;
  temperatorChart: Chart;

  startDate = new FormControl(moment());
  endDate = new FormControl(moment());
  entityName: string;
  selectedSensorData: any;
  sensorData: any;
  selectDateRange: any;
  ranges = {
    'Yesterday': [this.dateService.subDay(new Date(), 1), this.dateService.subDay(new Date(), 1)],
    'Last 7 days': [this.dateService.subDay(new Date(), 7), new Date()],
    //'Last 30 days': [this.dateService.subDay(new Date(), 30), new Date()],
    //'This month': [moment().startOf('month'), moment().endOf('month')]
  };
  colors = [
    '#234463',
    '#597D95',
    '#B5C9D2',
    '#EA0027'
  ];
  constructor(private dialogRef: MatDialogRef<SensorTrendModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe, private commonService: CommonService,
    public dialog: MatDialog,
    private dateService: DateService, private siteService: SiteService) {
    this.entityName = data.nodeName;
    this.sensorData = data.sensorDataList;
  }

  ngOnInit() {
  }
  onGenerate() {
    this.generateChart();
  }
  onClean() {
    const sensorTrendsContainerEl = document.querySelector('#SensorTrendsContainer');
    sensorTrendsContainerEl.innerHTML = '';
  }
  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm, data: null });
  }
  generateChart() {
    const fromDate =  moment(this.selectDateRange.startDate ? this.selectDateRange.startDate.valueOf() : '')
        .startOf('day').format('YYYY-MM-DD');

    const toDate = moment(this.selectDateRange.endDate ? this.selectDateRange.endDate.valueOf() : '')
      .endOf('day').format('YYYY-MM-DD');

    const sensorTrendParams = {
      'nodeId': this.data.nodeId,
      'NodeName': this.data.nodeName,
      'siteID': this.data.siteId,
      'startDate': fromDate,
      'endDate': toDate,
      'selectedSensor': this.selectedSensorData
    };
    if (Moment$(this.selectDateRange.endDate).diff(Moment$(this.selectDateRange.startDate), 'days') > 9) {
      this.onOpenAlertBox('Note: Data display limited to 10 days. Please select duration not more than 10 days');
    } else {
      this.siteService.getSensorTrendForGadgets(sensorTrendParams).subscribe(data => {
        if (data) {
          this.drawSensorTrends(data);
        }
      });
    }
    
  }

  private onOpenAlertBox = (description: string) => {
    const dialogRef = this.dialog.open(WarningDialog, { width: '50%' });
    dialogRef.componentInstance.confirmMessage = description;
  }

  transformDate(date: FormControl) {
    if (date.valid) {
      return this.datePipe.transform(date.value, 'yyyy-MM-dd');
    } else {
      return '';
    }
  }
  formatDate(date: any, format: string): string {
    return this.datePipe.transform(date, format) || '';
  }

  private processSeriesData(dataset, i: any) {
    const seriesData = [];
    if (dataset.parameterType !== 'Cleanliness') {
      seriesData.push({
        data: dataset.y.map(Number),
        name: dataset.title,
        yAxis: 0,
        type: 'areaspline',
        color: '#5CB85C',
        zones: [{
          value: dataset.lowerThreshold,
          color: '#C1C2C4',
        }, {
          value: dataset.upperThreshold,
          color: 'rgb(51,204,51)',
        }, {
          color: '#C1C2C4',
        }]
      });
    } else {
      // OPM Series data
      const chartType = 'line';

      seriesData.push({
        data: dataset.y.map(Number),
        name: dataset.title,
        type: chartType,
        color: this.colors[i % 4],
      });
    }

    return seriesData;
  }

  drawSensorTrends(data) {
    const sensorTrendsContainerEl = document.querySelector('#SensorTrendsContainer');
    sensorTrendsContainerEl.innerHTML = '';
    data.forEach((dataset, i) => {
      let seriesData = [];
      let showlegend = true;
      let yAxisTitle;
      let plotLinesArray = [];
      let valveStausCategories = [];
      let subTitleText = '';
      // Series data
      seriesData = this.processSeriesData(dataset, i);

      // Handling y-axis title and legend
      if ((dataset != null && dataset.x.length > 0)) {
        showlegend = true;
        valveStausCategories = [];

        // OutType of SWITCh should have CATEGORIES
        if (dataset.outputType === Constants.HYDRAULIC_OUTPUT_TYPE.Switch) {
          subTitleText = '';
          valveStausCategories = [];
          valveStausCategories.push(dataset.di_0);
          valveStausCategories.push(dataset.di_1);
          plotLinesArray = [];
        } else if (dataset.parameterType === 'Cleanliness') {
          // OPM
          // Threshold NOT required
          const parameterUnit = dataset.unit != null ? dataset.unit : '';
          subTitleText = '';
          plotLinesArray = [];
        } else {
          const parameterUnit = dataset.unit != null ? dataset.unit : '';
          subTitleText = 'Threshold  Value: ' + dataset.lowerThreshold + ' ' +
            dataset.unit + ' to ' + ' ' + dataset.upperThreshold + ' ' + dataset.unit + '<br/>';
          plotLinesArray.push({
            color: 'red',
            width: 3,
            value: dataset.lowerThreshold,
            label: {
              text: 'Lower Threshold'
            }
          }, {
            color: 'red',
            width: 3,
            value: dataset.upperThreshold,
            label: {
              text: 'Upper Threshold'
            }
          });
        }
        yAxisTitle = dataset.parameterTypeDisplayValue;
      } else {
        subTitleText = ' ' + '<br/>' + 'No Data Present for selected Date... !!!!' + '<br/>';
        yAxisTitle = '';
        showlegend = false;
      }

      // Container and Div
      const divClass = document.createElement('div');
      divClass.setAttribute('class', 'Sensor_TrendsChart');
      divClass.setAttribute('id', dataset.title);


      // Highcharts
      let opts: any;
      opts = {
        chart: {
          zoomType: 'x',
          spacingTop: 5,
          spacingBottom: 20,
        },
        title: {
          text: dataset.title,
          align: 'left',
          margin: 20,
          x: 75,
          style: {
            fontWeight: 'bold',
            fontSize: '20px',
          }
        },
        subtitle: {
          align: 'left',
          margin: 20,
          x: 75,
          text: subTitleText,
          style: {
            fontSize: '15px',
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          enabled: showlegend
        },
        xAxis: {
          crosshair: true,
          title: {
            text: 'Date & Time'
          },
          type: 'datetime',
          labels: {
            formatter: function () {
              return Highcharts$.dateFormat('%b %e, %Y %H:%M', this.value);
            }
          },
          categories: dataset.x,
          tickInterval: dataset.x.length / 6
        },
        navigation: {
          buttonOptions: {
            enabled: true
          }
        },
        yAxis: [{
          lineWidth: 1,
          title: {
            text: yAxisTitle,
          },
          // min: 0,
          labels: {
            formatter: function () {
              return this.value + dataset.unit;
            }
          },
          categories: valveStausCategories,
          plotLines: plotLinesArray,
        }],
        plotOptions: {
          series: {
            marker: {
              enabled: true
            },
            fillOpacity: 0.3,
            type: 'spline',
            turboThreshold: 0,
            threshold: null,
            animation: {
              //                                 duration: $scope.ST_TrendsChart_Animation_Duration

            },
            point: {}
          }
          // DataLabels above Column (OPM)
          //                       column: {
          //                           dataLabels: {
          //                               enabled: true
          //                           }
          //                       }
        },
        tooltip: {
          // shared: true,
          crosshairs: true,
          formatter: function () {
            // 'EEEE, MMM d, h:mm:ss'
            let toolTipData = '<font style="font-size: 10px;">' +
              Highcharts$.dateFormat('%b %e, %Y %H:%M:%S', this.x) +
              '</font>';
            let suffix;
            if (dataset.outputType === Constants.HYDRAULIC_OUTPUT_TYPE.Switch) {
              suffix = '<b>' + valveStausCategories[this.y] + ' </b> <br>';
            } else {
              suffix = '<b>' + this.y + '</b>' + dataset.unit + ' <br>';
            }
            toolTipData += '<br><span style="color: ' + this.series.color + '">\u25CF</span>' + this.series.name + ': ' + suffix;

            return toolTipData;
          }

        },
        series: seriesData
      };
      sensorTrendsContainerEl.appendChild(divClass);
      const newChart = Highcharts$.chart(divClass, opts);
    });

  }
  onChangeDateRange() {
    if (this.commonService.isLaterThanCurentDate(this.selectDateRange.endDate)) {
      this.commonService.showDialogMessage(Constants.FUTURE_DATE_NOT_ALLOW);
      return;
    }
  }
}
